const BaseModule = require('../../90_utils/base/BaseModule');

class AutoRotator extends BaseModule {

	constructor(el, params) {

		super(el);

		// param defaults

		this.defaults = {
			slideDelay: 			4, // seconds
			introDelay: 			0.5, // seconds
			elementId: 				'data-ar-item'
		};

		this.updateParams(params);

		// vars

		this.$activeSlide;

		this._isPaused = false;
		this._isHoverPaused = false;

		this._interval;
		this._introTimeout;
	}

	updateParams(params){

		this.params = params || {};

		this.slideDelay = parseFloat(this.checkVal(this.params.slideDelay, this.defaults.slideDelay));
		this.introDelay = parseFloat(this.checkVal(this.params.introDelay, this.defaults.introDelay));
		this.elementId = this.checkVal(this.params.elementId, this.defaults.elementId);
	}

	// private methods

	_domReady(){

		this.$slides = this.$el.find('[' + this.elementId + ']');
		this.resume();

		super._domReady();
	}

	_addListeners(){

		if(!this._isListening){

			this._isListening = true;

			this.$el.on('mouseenter', this._onOver.bind(this));
			this.$el.on('mouseleave', this._onOut.bind(this));
		}

		super._addListeners();
	}

	_removeListeners(){

		if(this._isListening){

			this._isListening = false;

			this.$el.off('mouseenter', this._onOver.bind(this));
			this.$el.off('mouseleave', this._onOut.bind(this));
		}

		super._removeListeners();
	}

	// element event listeners

	_onOver(){
		this.pause(true);
	}

	_onOut(){
		this.resume(true);
	}

	// pause / resume slideshow

	pause(fromHover){

		if(!this._isPaused){

			if(fromHover && !this._isHoverPaused){
				this._isPaused = true;
				this._isHoverPaused = true;
			}
			else if(!fromHover && !this._isHoverPaused) {
				this._isPaused = true;
				this._isHoverPaused = false;
			}
		}

		if(this._isPaused){
			this.clearInterval();
		}
	}

	resume(fromHover){

		if(this._isPaused){

			if(fromHover && this._isHoverPaused){
				this._isPaused = false;
				this._isHoverPaused = false;
			}
			else if(!fromHover && !this._isHoverPaused) {
				this._isPaused = false;
				this._isHoverPaused = false;
			}
		}

		if(!this._isPaused){
			this.resetInterval();
		}
	}

	//

	resetInterval(){

		if(this._interval){ this.clearInterval(); }
		this._interval = window.setInterval(this.		tick.bind(this), this.slideDelay * 1000);

		if(!this.$activeSlide || !this.$activeSlide.length){ this.tick(); }
	}

	clearInterval(){

		if(this._interval){
			window.clearInterval(this._interval);
			this._interval = null;
		}
	}

	//

	tick(){

		let index = this.$activeSlide && this.$activeSlide.length ? this.$activeSlide.index() : -1;
		let nextIndex = window.utils.NumberUtils.getRangeIndex(index+1, 0, this.$slides.length, true);
		let $nextSlide = this.$slides.eq(nextIndex);

		if(this.$activeSlide){ this.$activeSlide.removeClass('is-active'); }

		this.$activeSlide = $nextSlide;

		// interval

		if(this._introTimeout){ window.clearTimeout(this._introTimeout); }

		this._introTimeout = window.setTimeout(() => {
			this.$activeSlide.addClass('is-active');
			this._introTimeout = null;
		}, this.introDelay * 1000);
	}

	//

	_domUpdate(){ } // use me!
	_resize(){ } // use me!
}

module.exports = AutoRotator;
